import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService, { type IResponse } from 'services/dataService';
import { apiUpdateTask } from 'services/dataService/resources/oneplatform/api';

import { QUERY_KEYS } from '../constants';

import type { IEditTaskPayload } from '../types';

interface IEditTaskVariables {
  taskGuid: string;
  payload: IEditTaskPayload;
}

export function useEditDashboardTask() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ taskGuid, payload }: IEditTaskVariables) =>
      dataService.patchOnly(apiUpdateTask(taskGuid), payload),
    onSuccess: (response: IResponse<unknown>) => {
      if (response.error) {
        notificationController.error({
          message: t('tasksDashboard.editError'),
        });
        return;
      }

      notificationController.success({
        message: t('tasksDashboard.editSuccess'),
      });
      queryClient.invalidateQueries([QUERY_KEYS.dashboardTasks]);
    },
  });
}
